import React, { useContext } from 'react'

import { PageName } from 'generated/types'
import { FunnelContext } from 'utils/FunnelContext'

import { ProminenceBanner } from './ProminenceBanner'

interface Props {
  pageName: PageName
  eventObjectName: string
}

export const FunnelContent = (props: Props) => {
  const { getContent } = useContext(FunnelContext)
  const content = getContent(props.pageName)

  switch (content?.__typename) {
    case 'RegistrationProminenceBannerContent':
      return <ProminenceBanner content={content} eventObjectName={props.eventObjectName} />
    default:
      return null
  }
}
